import round from "../../../utils/round";

/**
 * Get progress
 * @param {PropertyValueProps} property
 * @param {Number} percents
 * @param {Boolean} enter
 * @param {Boolean} spring
 * @returns
 */
const getProgressTime = (property, percents, enter, spring) => {
  let progress = 0;

  const easing = /** @type {Function} */ (property.get("o_easing"));

  if (enter) {
    const lastLeaveProgress = /** @type {Number} */ (
      property.get("leave-progress")
    );

    progress = lastLeaveProgress + (1 - lastLeaveProgress) * easing(percents);
    property.set("enter-progress", progress);
  } else {
    const lastEnterProgress = /** @type {Number} */ (
      property.get("enter-progress")
    );

    progress = lastEnterProgress - lastEnterProgress * easing(percents);
    property.set("leave-progress", progress);
  }

  progress = round(progress);

  property.set("progress", progress);

  if (spring) {
    if (percents === 1) {
      if (enter) {
        progress = 1;
      } else {
        progress = 0;
      }
    }
  }

  const array = /** @type {Array<Number>} */ (
    property.get("last-progress-array")
  );

  array.push(progress);

  property.set("last-progress-array", array.slice(-2));

  return progress;
};

export default getProgressTime;
